module.exports = __webpack_public_path__ + "img/claves-valor-tway-horizontal.8dc6b1c0.svg";